export default {"src":"/_next/static/media/carBrandLightBg_104.941e94b6.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};